import { encode } from 'js-base64';

// 处理用户的创建和更新
import { ref, Ref } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import tips from '@/renderer/scripts/utils/tips';
import smh, { SMH } from '@/renderer/scripts/smh';
import { PAY_SOURCE, openTeamPayDialog } from '@/renderer/scripts/composition/dialogHandler';
type UpdateParams = {
  userId: number;
  form: SMH.UpdateUserParams;
  capacityChanged: boolean;
  allowPersonalSpaceChanged: boolean;
  originAccountName?: string;
  accountNameChanged: boolean;
};
type Handler = {
  userId: Ref<number | null>;
  userInfo: Ref<SMH.CreateUserParams | {}>;
  createUser: (userInfo: SMH.CreateUserParams) => Promise<boolean>;
  updateUser: (params: UpdateParams) => Promise<boolean>;
};
export default function submitHandler(): Handler {
  const userId: Ref<number | null> = ref(null);
  const userInfo: Ref<SMH.CreateUserParams | {}> = ref({});
  const methods = {
    // 创建用户
    async createUser(userInfo: SMH.CreateUserParams) {
      let isSuccessful = true;
      if (userInfo.accountPassword) {
        Object.assign(userInfo, {
          accountPassword: encode(userInfo.accountPassword as string),
        });
      }
      try {
        tips.loading(i18n_t('正在处理'), 0);
        await smh.userAPI.createUser(userInfo);
        tips.success(i18n_t('新建成功'), 2000);
      } catch (e: any) {
        if (e?.code === 'UserLimitReached') {
          openTeamPayDialog(PAY_SOURCE.USER_LIMIT);
          tips.closeAll();
        } else {
          tips.error(e as MsgError);
        }
        isSuccessful = false;
      }
      return isSuccessful;
    },
    // 更新用户信息
    async updateUser(params: UpdateParams) {
      let isSuccessful = true;
      const { userId, form, allowPersonalSpaceChanged, capacityChanged, accountNameChanged, originAccountName } =
        params;
      const {
        countryCode,
        phoneNumber,
        nickname,
        email,
        role,
        enabled,
        comment,
        allowPersonalSpace,
        personalSpaceQuotaSize,
      } = form;
      const updateUserInfo: SMH.UpdateUserParams = {
        userId,
        countryCode,
        phoneNumber,
        nickname,
        email,
        role,
        enabled,
        comment,
        allowPersonalSpace,
        personalSpaceQuotaSize: personalSpaceQuotaSize || '',
      };
      // 新开启的个人空间需要传配额
      if (allowPersonalSpaceChanged && updateUserInfo.allowPersonalSpace) {
        updateUserInfo.personalSpaceQuotaSize = personalSpaceQuotaSize;
      }
      try {
        tips.loading(i18n_t('正在处理'), 0);
        // 只有开启个人空间情况下(不是新开启的个人空间),空间容量专门设置
        if (updateUserInfo.allowPersonalSpace && capacityChanged && !allowPersonalSpaceChanged) {
          await smh.userAPI.setUserQuota({
            userId,
            capacity: personalSpaceQuotaSize as string,
          });
        }
        // 修改账户
        if (form.accountName && accountNameChanged) {
          await smh.userAPI.updateAccountName({
            originalAccountName: originAccountName as string,
            newAccountName: form.accountName as string,
          });
        }
        await smh.userAPI.updateUser(updateUserInfo);
        tips.success(i18n_t('修改成功'), 2000);
      } catch (e) {
        isSuccessful = false;
        tips.error(e as MsgError);
      }
      return isSuccessful;
    },
  };
  return {
    userId,
    userInfo,
    ...methods,
  };
}
